import React, { useEffect, createContext, useReducer } from 'react';

import { GlobalStateReducer, initialState } from '../reducers/GlobalStateReducer';

import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import {FormattedMessage, injectIntl} from "react-intl";
import Toaster from "@amzn/meridian/toaster";
import Alert from "@amzn/meridian/alert";
import {checkValidLink, getRandomInt} from "../../util/Util";
import {getLocalizedMessage} from "../../util/Localization";
import Input from "@amzn/meridian/input"
import Column from "@amzn/meridian/column"
import RadioButton from "@amzn/meridian/radio-button"
import {MCM, TICKET, JUSTIFICATION, MERIDIAN_ALERT_TYPE} from "../../util/Constants";
import {FeatureUtility} from "../../util/FeatureUtility";

export const GlobalStateContext = createContext();

const GlobalStateContextProvider = ({intl, children}) => {
  const [globalState, dispatchGlobal] = useReducer(GlobalStateReducer, initialState);
  const setAsyncError = (asyncError) => {
    dispatchGlobal({
      type: 'SET_ASYNC_ERROR',
      data: {
        asyncError
      }
    });
  };
  const restartApp = () => {
    dispatchGlobal({
      type: 'RESTART_APP'
    });
  };
  const showWarning = (msg, callBack) => {
    dispatchGlobal({
      type: 'SET_WARNING',
      data: {
        warningMsg: msg,
        warningAction: callBack
      }
    });
  }
  const onCloseModal = () => {
    dispatchGlobal({
      type: 'SET_WARNING',
      data: {
        warningMsg: '',
        warningAction: () => {}
      }
    });
  }

  const showCustomAlert = (message, type = MERIDIAN_ALERT_TYPE.INFO) => {
    const id = getRandomInt(100);
    dispatchGlobal({
      type: 'SHOW_CUSTOM_ALERT',
      data: {
        toast: {id, message, type},
      }
    });
  }

  const closeCustomAlert = (toastId) => {
    dispatchGlobal({
      type: 'CLOSE_CUSTOM_ALERT',
      data: {
        toastId: toastId
      }
    });
  }

  const setLink = (link) => {
    dispatchGlobal({
      type: 'SET_LINK',
      data: {
        link: link,
      }
    });
  }

  const setLinkTab = (linkTab) => {
    dispatchGlobal({
      type: 'SET_LINK_TAB',
      data: {
        linkTab: linkTab,
      }
    });
  }

  const setLoadingFeatures = (loadingFeatures) =>{
    dispatchGlobal({
      type: 'SET_LOADING_FEATURES',
      data: {
        loadingFeatures: loadingFeatures,
      }
    });
  }

  useEffect(() => {
    (async () => {
      FeatureUtility.setAllFeatureStatuses().then(response =>{
        setLoadingFeatures(true);
      });
    })();
  }, []);

  const value = {
    ...globalState,
    setAsyncError,
    restartApp,
    showWarning,
    showCustomAlert,
    closeCustomAlert,
  };

  return <GlobalStateContext.Provider value={value}>
    {children}

    { (globalState.toasts.length > 0) &&
      <Toaster toasts={globalState.toasts} onCloseToast={closeCustomAlert} alignmentHorizontal="center">
      { toast =>
          <Alert toast={true} onClose={() => toast.onClose(toast.id)} type={toast.type}>
            {getLocalizedMessage({intl, stringId:toast.message})}
          </Alert>
      }
      </Toaster>
    }
    <Modal
        title={<FormattedMessage id="common.warning" defaultMessage="Warning"/>}
        open={globalState.warningMsg}
        onClose={()=> {onCloseModal(); setLink("")}}
        scrollContainer="viewport"
        closeLabel="Close"
    >
      <Column>
        <Text>{globalState.warningMsg}</Text>
        <Row>
          <RadioButton
              checked={globalState.linkTab === MCM}
              onChange={setLinkTab}
              value={MCM}
          >
            <Text>{getLocalizedMessage({intl,stringId:"device.mcm"})}</Text>
          </RadioButton>
          <RadioButton
              checked={globalState.linkTab === TICKET}
              onChange={setLinkTab}
              value={TICKET}
          >
            <Text>{getLocalizedMessage({intl,stringId:"device.ticket"})}</Text>
          </RadioButton>
          <RadioButton
              checked={globalState.linkTab === JUSTIFICATION}
              onChange={setLinkTab}
              value={JUSTIFICATION}
          >
            <Text>{getLocalizedMessage({intl,stringId:"device.justification"})}</Text>
          </RadioButton>
        </Row>
        <Input
            id="link"
            value={globalState.link}
            onChange={setLink}
            type="text"
            placeholder={getLocalizedMessage({intl,stringId:"device.linkPlaceHolder"})}
            error={!checkValidLink(globalState.linkTab, globalState.link)}
        />
      </Column>
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          <Button type="tertiary" size="small" onClick={()=>{onCloseModal();setLink("")}}>
            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
          </Button>
          <Button type="primary" size="small" disabled={!checkValidLink(globalState.linkTab,globalState.link)} onClick={() => {
            setLink("");
            globalState.warningAction();
            onCloseModal();
          }}>
            <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  </GlobalStateContext.Provider>;
};
export default injectIntl(GlobalStateContextProvider)



// WEBPACK FOOTER //
// ./src/components/global/context/GlobalStateContext.js